import { settings } from "@/lib/utils/settings/settings";
import { formHeaderClassNames } from "@/shared/constants/customStyleSets";

const EpsMomentumLink = () => (
	<a
		href={settings.landingPageUrl}
		className="hover:underline font-bold text-gold"
		target="_blank"
		rel="noreferrer"
		aria-label="Visit EPSMomentum website (opens in new tab)"
	>
		EPSMomentum.com
	</a>
);

export function FirstMessage() {
	return (
		<div className="text-lg flex flex-col items-center justify-center h-full max-w-[70%]">
			<h2 className={formHeaderClassNames}>Congratulations!</h2>

			<p className="text-center mb-4">
				You have joined the growing band of investors who use{" "}
				<EpsMomentumLink /> to select stocks worthy of being in your portfolio.
			</p>

			<p className="text-center mb-4">
				Please complete the very quick profile builder.
			</p>

			<p className="text-center mb-4">
				Thanks for subscribing and enjoy using the platform.
			</p>
		</div>
	);
}
